import Modal from "@atomaro/ui-kit/components/Modal/Modal";
import {FC} from "react";
import {
    NewDeviceSuccessButtonsCol,
    NewDeviceSuccessContent,
    NewDeviceSuccessHeaderRow, NewDeviceSuccessSubtitle
} from "widgets/newDeviceModal/ui/styles.ts";
import {Button} from "@atomaro/ui-kit";

export type NewDeviceSuccessProps = {
    onreturn: () => void,
    onclose: () => void,
}

export const NewDeviceSuccess: FC<NewDeviceSuccessProps> = ({onreturn, onclose}) => {
    return (
        <Modal
            isOpen={true}
            centered
            style={{ padding: 0, maxHeight: "100%", width: "90%", maxWidth: "320px" }}
            onClickOverlay={onclose}
        >
            <NewDeviceSuccessContent>
                <NewDeviceSuccessHeaderRow>
                    <h3>Устройство успешно подключено к улью</h3>
                    <svg onClick={onclose} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="24.000000" height="24.000000" fill="none">
                        <rect width="24" height="24" x="0" y="0" />
                        <path d="M10.9401 12.0006L4.99902 17.9417L6.05968 19.0023L12.0008 13.0612L17.9418 19.0023L19.0025 17.9417L13.0614 12.0006L19.0025 6.0595L17.9418 4.99884L12.0008 10.9399L6.0597 4.99884L4.99904 6.0595L10.9401 12.0006Z" fill="rgb(16,24,40)" fillRule="evenodd" />
                    </svg>
                </NewDeviceSuccessHeaderRow>
                <NewDeviceSuccessSubtitle>
                    Вы всегда можете отключить устройство от улья в разделе “Управление устройствами”
                </NewDeviceSuccessSubtitle>
                <NewDeviceSuccessButtonsCol>
                    <Button
                        label={"Отлично"}
                        onClick={() => onclose()}
                    />
                    <Button
                        colorScheme={'neutral'}
                        variant={'ghost'}
                        label={"Подключите ещё устройство"}
                        onClick={() => onreturn()}
                    />
                </NewDeviceSuccessButtonsCol>
            </NewDeviceSuccessContent>
        </Modal>
    );
};

